import { Box } from '@smartfm/ui/components/Box';
import { Typography } from '@smartfm/ui/components/Typography';
import IslandPicture from '@smartfm/ui/icons/IslandPicture';

export function SelectBuildingState() {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Take into account only the picture size for centering */}
      <Box sx={{ width: '302px', whiteSpace: 'nowrap' }}>
        <IslandPicture />
        <Box sx={{ paddingBottom: 1 }}>
          <Typography variant='Calibre/H6 Headline'>
            Please select a building
          </Typography>
        </Box>
        <Box sx={{ paddingBottom: 1 }}>
          <Typography variant='Calibre/Body 2'>
            Insights cannot be displayed for multiple buildings simultaneously.
          </Typography>
        </Box>
        <Box>
          <Typography variant='Calibre/Body 2'>
            Please select a specific building to view its insights.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
